import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from './NavIcons';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-full bg-raya-card hover:bg-raya-accent-light transition-all duration-300 border border-transparent hover:border-raya-accent/30 group"
      >
        <span className="font-medium text-raya-text-secondary group-hover:text-raya-accent transition-colors">
            {i18n.language === 'am' ? 'አማ' : 'En'}
        </span>
        <ChevronDownIcon className={`w-4 h-4 text-raya-text-tertiary group-hover:text-raya-accent transition-all duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {isOpen && (
            <motion.div
                initial={{ opacity: 0, y: 10, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 10, scale: 0.95 }}
                transition={{ duration: 0.2 }}
                className="absolute right-0 mt-2 w-32 bg-raya-card rounded-xl shadow-xl border border-raya-border overflow-hidden z-50"
            >
                <div className="py-1">
                    <button
                        onClick={() => changeLanguage('en')}
                        className={`w-full text-left px-4 py-2 text-sm hover:bg-raya-accent-light transition-colors ${i18n.language === 'en' ? 'text-raya-accent font-bold bg-raya-accent/10' : 'text-raya-text-secondary'}`}
                    >
                        English
                    </button>
                    <button
                        onClick={() => changeLanguage('am')}
                        className={`w-full text-left px-4 py-2 text-sm hover:bg-raya-accent-light transition-colors ${i18n.language === 'am' ? 'text-raya-accent font-bold bg-raya-accent/10' : 'text-raya-text-secondary'}`}
                    >
                        አማርኛ
                    </button>
                </div>
            </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LanguageSwitcher;
